<template>
  <div
    class="text-chip"
    :class="[{red:red,thin:thin,gray:gray,small:small,big:big,yellow:yellow,blue:blue,green:green,'has-bg':hasBg, 'no-wrap':noWrap},color]"
    :style="{marginTop:marginTop+'px',color:color}"
  >
    <i
      class="leading-icon"
      :class="[leadingIcon,{iconLg:iconLg,iconMd:iconMd,iconSm:iconSm,iconXl:iconXl,iconXs:iconXs}]"
    />
    <p
      class="text-chip_text"
      :class="{fontSizeLg:fontSizeLg,fontSizeMd:fontSizeMd,fontSizeSm:fontSizeSm,fontSizeXl:fontSizeXl,fontSizeXs:fontSizeXs,'dark':isDarkText}"
    >
      {{ textLabel }}<span v-if="num">{{ num }}</span><span
        v-if="hasPercent"
        class="text-chip_text-percent"
      >%</span>
    </p>
  </div>
</template>
<script>
export default {
  name: "TextChip",
  props: {
    hasBg: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    textLabel: {
      type: String,
      default: "",
    },
    red: {
      type: Boolean,
      default: false,
    },
    thin: {
      type: Boolean,
      default: false,
    },
    icon24: {
      type: Boolean,
      default: false,
    },
    num: {
      type: Number,
      default: 0,
    },
    gray: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    big: {
      type: Boolean,
      default: false,
    },
    yellow: {
      type: Boolean,
      default: false,
    },
    blue: {
      type: Boolean,
      default: false,
    },
    iconSize: {
      type: Number,
      default: 1.125,
    },
    fontSize: {
      type: Number,
      default: 1,
    },
    green: {
      type: Boolean,
      default: false,
    },
    iconXl: {
      type: Boolean,
      default: false,
    },
    iconLg: {
      type: Boolean,
      default: false,
    },
    iconMd: {
      type: Boolean,
      default: false,
    },
    iconSm: {
      type: Boolean,
      default: false,
    },
    iconXs: {
      type: Boolean,
      default: false,
    },
    fontSizeLg: {
      type: Boolean,
      default: false,
    },
    fontSizeXs: {
      type: Boolean,
      default: false,
    },
    fontSizeSm: {
      type: Boolean,
      default: false,
    },
    fontSizeMd: {
      type: Boolean,
      default: false,
    },
    fontSizeXl: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
    hasPercent: {
      type: Boolean,
      default: false,
    },
    isDarkText: {
      type: Boolean,
      default: false,
    },
    noWrap: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/text-chip";
</style>